import { render, staticRenderFns } from "./CreateAppDownloadPhotoPlus.vue?vue&type=template&id=71d8bb72&scoped=true&"
import script from "./CreateAppDownloadPhotoPlus.vue?vue&type=script&lang=js&"
export * from "./CreateAppDownloadPhotoPlus.vue?vue&type=script&lang=js&"
import style0 from "./CreateAppDownloadPhotoPlus.vue?vue&type=style&index=0&id=71d8bb72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d8bb72",
  null
  
)

export default component.exports